import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Composants globaux
import Header from './components/Header';
import StockDetailModal from './components/StockDetailModal';
import { StockModalProvider } from './context/StockModalContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Pages Publiques
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import GuidePage from './pages/GuidePage';
import PricingPage from './pages/PricingPage'; // NOUVEAU : Page des tarifs

// Pages Privées (Outils & Dashboard)
import Dashboard from './pages/DashboardPage';
import PortfolioPage from './pages/PortfolioPage';
import ScreenerPage from './pages/ScreenerPage';
import WatchlistPage from './pages/WatchlistPage';
import ProfilePage from './pages/ProfilePage';
import ArenaPage from './pages/ArenaPage';
import ComparePage from './pages/ComparePage'; 
import ValuationPage from './pages/ValuationPage';
import InsiderRadarPage from "./pages/InsiderRadarPage";
import CatalystCalendarPage from "./pages/CatalystCalendarPage";
import HeatmapPage from './pages/HeatmapPage';
import AdminPage from './pages/AdminPage';

// Protection des routes membres
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <StockModalProvider>
      <NotificationProvider>
        <Router>
          <Header />
          <StockDetailModal />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/pricing" element={<PricingPage />} /> {/* NOUVEAU */}
            
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/portfolio" element={<PrivateRoute><PortfolioPage /></PrivateRoute>} />
            <Route path="/watchlist" element={<PrivateRoute><WatchlistPage /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
            <Route path="/screener" element={<PrivateRoute><ScreenerPage /></PrivateRoute>} />
            <Route path="/insiders" element={<PrivateRoute><InsiderRadarPage /></PrivateRoute>} />
            <Route path="/calendar" element={<PrivateRoute><CatalystCalendarPage /></PrivateRoute>} />
            <Route path="/compare" element={<PrivateRoute><ComparePage /></PrivateRoute>} />
            <Route path="/valuation" element={<PrivateRoute><ValuationPage /></PrivateRoute>} />
            <Route path="/heatmap" element={<PrivateRoute><HeatmapPage /></PrivateRoute>} />
            <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
            
            <Route path="/arena" element={<ArenaPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </StockModalProvider>
  );
}

export default App;
